    document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".add-to-cart-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const form = btn.closest("form");
      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log("Added to cart:", data);
          //openCartDrawer(); // See step 3
          document.querySelector('.cart-link')?.click();
        })
        .catch(error => {
          console.error("Add to cart error:", error);
        });
    });
  });
});